import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyBoardRoute: InvariantJiraRoute = {
	name: 'legacy-board',
	path: '/secure/RapidBoard.jspa',
};
